import _ from './Trans';
import {Row, Container, Col} from 'reactstrap';
import React, {useEffect, useRef} from "react";
import Config from "./Config";
import ReactGA from "react-ga4";
import {faUserGroup, faTrophy, faAward, faRightFromBracket, faUserGear, faPersonChalkboard, faNewspaper, faUsersViewfinder, faEnvelope} from '@fortawesome/free-solid-svg-icons'
import {faXTwitter, faInstagram, faFacebook, faLinkedin, faTiktok, faYoutube} from "@fortawesome/free-brands-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {NavLink} from "react-router-dom";
import ComparePlayers from "./partials/CompareModal";

export default function Extra({navbar, isMobile}) {
    useEffect(() => {
        ReactGA.initialize(Config.GA_CODE);
        ReactGA.send({hitType: "pageview", page: "/extra/", title: "Extra"});
    }, []);

    const modalRef = useRef();

    const customToggle = function() {
        modalRef.current?.toggle();
    }

    return (
        <Container className="w-100">
            <ComparePlayers ref={modalRef}/>

            {isMobile ? "" : navbar}
            <Row className="mt-5">
                {Config.extraConfig.myAccountEnabled &&
                    <ExtraIcon navlink={"/profile/"} icon={faUserGear} text={_('My account')}></ExtraIcon>
                }

                <ExtraIcon navlink={"/rules/"} icon={faPersonChalkboard} text={_('Rules')}></ExtraIcon>

                <ExtraIcon navlink={"/invite-friends/"} icon={faUserGroup} text={_('Invite friends')}></ExtraIcon>

                {Config.extraConfig.newsEnabled &&
                    <ExtraIcon navlink={"/news/"} icon={faNewspaper} text={_('News')}></ExtraIcon>
                }

                <ExtraIcon navlink={"/tournaments/"} icon={faTrophy} text={_('Tournaments')}></ExtraIcon>

                <ExtraIcon clickHandler={customToggle} icon={faUsersViewfinder} text={_('Compare')}></ExtraIcon>

                <ExtraIcon navlink={"/trophies/"} icon={faAward} text={_('Trophies')}></ExtraIcon>

                <ExtraLink href={Config.logoutPage} icon={faRightFromBracket} text={_('Logout')}></ExtraLink>

                <Col xs={12} className="mt-3 ml-2 mr-2 extra-footer">
                    <h2 className="h5">{_('Contact')}</h2>
                </Col>
                <Col xs={12} sm={6} className="ml-2 ml-sm-0 extra-footer">
                    <h5 className="h6">{_('Support and feedback')}</h5>
                    <a href={"mailto:"+Config.contactEmail} target="_blank" rel="noreferrer" className="extra-pill-icon extra-contact-icon">
                        <FontAwesomeIcon icon={faEnvelope}/>
                    </a>
                </Col>
                <Col xs={12} sm={6} className="ml-2 mr-2 ml-sm-0 mr-sm-0 extra-footer">
                    <h5 className="h6">{_('Social')}</h5> <TwitterIcon/> <InstagramIcon/> <FacebookIcon/> <LinkedInIcon/> <TikTokIcon/> <YoutubeIcon/>
                </Col>
            </Row>
            <Row style={{'marginTop': '15vh'}}></Row>
        </Container>
    );
}

const ExtraIcon = function({icon, text, navlink, clickHandler}) {
    return (
        <Col xs={6} md={4} className="d-flex justify-content-center mb-3">
            {navlink &&
            <NavLink to={navlink}>
                <div className="align-middle extra-pill">
                    <FontAwesomeIcon icon={icon} className="extra-pill-icon"></FontAwesomeIcon><br/>
                    {text}
                </div>
            </NavLink>
            }
            {clickHandler &&
                <div className="align-middle extra-pill link font-weight-bold" onClick={clickHandler}>
                    <FontAwesomeIcon icon={icon} className="extra-pill-icon"></FontAwesomeIcon><br/>
                    {text}
                </div>
            }
            {!navlink && !clickHandler &&
                <div className="align-middle extra-pill link">
                    <FontAwesomeIcon icon={icon} className="extra-pill-icon"></FontAwesomeIcon><br/>
                    {text}
                </div>
            }
        </Col>
    )
}

const ExtraLink = function({icon, text, href}) {
    return (
        <Col xs={6} md={4} className="d-flex justify-content-center mb-3">
            <a href={href}>
                <div className="align-middle extra-pill">
                    <FontAwesomeIcon icon={icon} className="extra-pill-icon"></FontAwesomeIcon><br/>
                    {text}
                </div>
            </a>
        </Col>
    )
}

const TwitterIcon = function() {
    return (
        <LinkIcon link={process.env?.REACT_APP_TWITTER_ICON} icon={faXTwitter}></LinkIcon>
    );
}

const InstagramIcon = function () {
    return (
        <LinkIcon link={process.env?.REACT_APP_INSTAGRAM_ICON} icon={faInstagram}></LinkIcon>
    );
}

const FacebookIcon = function () {
    return (
        <LinkIcon link={process.env?.REACT_APP_FACEBOOK_ICON} icon={faFacebook}></LinkIcon>
    );
}

const LinkedInIcon = function () {
    return (
        <LinkIcon link={process.env?.REACT_APP_LINKEDIN_ICON} icon={faLinkedin}></LinkIcon>
    );
}

const TikTokIcon = function () {
    return (
        <LinkIcon link={process.env?.REACT_APP_TIKTOK_ICON} icon={faTiktok}></LinkIcon>
    );
}

const YoutubeIcon = function () {
    return (
        <LinkIcon link={process.env?.REACT_APP_YOUTUBE_ICON} icon={faYoutube}></LinkIcon>
    );
}

const LinkIcon = function ({link, icon, extraClassName}) {
    return (
        <>
        {link &&
        <a href={link} target="_blank" rel="noreferrer" className={"extra-pill-icon extra-contact-icon " + extraClassName} style={{paddingRight: '15px'}}>
            <FontAwesomeIcon icon={icon}></FontAwesomeIcon>
        </a>
        }
        </>
    )
}